<div class="back-to-top" [ngClass]="{'hide': !scrolledDown}" (click)="scrollToTop()">
  <span></span>
</div>
<footer class="page-footer">
  <section class="content">
<!--    <div class="footer-logo">-->
<!--      <div class="logo">-->
<!--        <img src="https://cdn.ihs.com/www2/gps/img/IHSM_Logo_w.svg" alt="IHS Logo">-->
<!--      </div>-->
<!--    </div>-->
    <div class="footer-links">
      <div class="footer-section">
        <nav>
          <ul>
            <li><a href="https://ihsmarkit.com/products.html">Products &amp; Solutions</a></li>
            <li><a href="https://ihsmarkit.com/expertise/index.html">Our Expertise</a></li>
            <li><a href="https://careers.ihsmarkit.com/">Jobs</a></li>
            <li><a href="https://ihsmarkit.com/company/index.html">Company</a></li>
          </ul>
        </nav>
      </div>
      <div class="footer-section">
        <nav>
          <ul>
            <li><a href="https://ihsmarkit.com/login.html">IHS Markit Customer Login</a></li>
            <li><a href="https://ihsmarkit.com/about/corporate-sustainability.html">Corporate Sustainability</a></li>
            <li><a href="https://investor.ihsmarkit.com/">Investor Relations</a></li>
            <li><a href="http://news.ihsmarkit.com/">Newsroom</a></li>
          </ul>
        </nav>
      </div>
      <div class="footer-section">
        <nav>
          <ul>
            <li><a href="https://ihsmarkit.com/about/contact-us.html">Contact Us</a></li>
            <li><a href="https://ihsmarkit.com/about/locations.html">Locations</a></li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="footer-social">
      <a href="https://www.linkedin.com/company/ihsmarkit/" title="Linkedin"><span class="linkedin"></span></a>
      <a href="https://twitter.com/ihsmarkit" title="Twitter"><span class="twitter"></span></a>
      <a href="https://www.youtube.com/IHSMarkit" title="Youtube"><span class="youtube"></span></a>
      <a href="https://www.facebook.com/IHSMarkit" title="Facebook"><span class="facebook"></span></a>
    </div>
  </section>
  <section class="content">
    <div class="footer-lower">
      <div class="footer-legal">
        <nav>
          <ul>
            <li><a href="https://ihsmarkit.com/Legal/modern-slavery-statement.html">Modern Slavery Act Statement</a></li>
            <li><a href="https://ihsmarkit.com/Legal/privacy.html">Privacy</a></li>
            <li><a href="https://ihsmarkit.com/Legal/terms-of-use.html">Terms of Use</a></li>
            <li><a href="https://ihsmarkit.com/Legal/po-tc.html">Purchase Order Terms and Conditions</a></li>
<!--            <li><a href="https://ihsmarkit.com/Legal/disclaimers.html">Disclaimers</a></li>-->
<!--            <li><a href="https://ihsmarkit.com/Legal/index.html">Legal</a></li>-->
            <li><a href="https://ihsmarkit.com/Legal/accessibility.html">Accessibility</a></li>
            <li><a href="http://more.ihs.com/DoNotSell">California Do Not Sell My Personal Information</a></li>
          </ul>
        </nav>
      </div><div class="footer-copyright">© {{currentYear}} S&P Global</div>
    </div>
  </section>
</footer>
